import React from "react";
import {
  AiFillExclamationCircle,
  AiOutlineArrowDown,
  AiOutlineArrowUp,
  AiOutlineBarChart,
  AiFillLinkedin,
} from "react-icons/ai";
import SideBar from "../../Components/Navbar/Sidebar";
import "./dashboard.css";
// import { Card, CardBody, CardTitle, Row, div } from 'reactstrap';

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { FaRupeeSign, FaShoppingCart } from "react-icons/fa";
import { BsBookmark } from "react-icons/bs";
import { BiCalendar } from "react-icons/bi";
import { MdRefresh } from "react-icons/md";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getAllOrder,
  goUsers,
  incartUsers,
  venders,
} from "../../Components/Apis/apis";
import { useState } from "react";
ChartJS.register(ArcElement, Tooltip, Legend);
const DashBoard = () => {
  const navigate = useNavigate();
  const { loading, user } = useSelector((state) => state.user);
  const [client, setClients] = useState([]);
  const [alluser, setusers] = useState([]);
  const [followersCount, setFollowersCount] = useState(0);

  const data = {
    labels: ["Red", "Blue", "Yellow", "Green", "Orange"],

    datasets: [
      {
        data: [400, 50, 100, 80, 150],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#00cc99",
          "#ffa31a",
        ],
        hoverBackgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#00cc99",
          "#ffa31a",
        ],
      },
    ],
  };

  const clients = async () => {
    const data = await getAllOrder();
    setClients(data.length);
  };
  const users = async () => {
    const data = await goUsers();
    setusers(data.length);
  };

  const pageCards = [
    {
      pageCardIcon: <AiOutlineBarChart />,
      pageCardtitle: "Users",
      pageCardValue: alluser,
      pageCardFooterIcon: <AiFillExclamationCircle />,
      pageCardFooterDes: "81% lower growth",
      iconColor: "red",
      path: "/users",
    },
    {
      pageCardIcon: <FaShoppingCart />,
      pageCardtitle: "Orders",
      pageCardValue: client,
      pageCardFooterIcon: <BsBookmark />,
      pageCardFooterDes: "Total orders",
      iconColor: "#ffc107",
      path: "/order",
    },
    {
      pageCardIcon: <FaRupeeSign />,
      pageCardtitle: "Revenue",
      pageCardValue: "0000",
      pageCardFooterIcon: <BiCalendar />,
      pageCardFooterDes: " Sales Per Month/Year",
      iconColor: "#28a745",
      path: "/revenue",
    },
  ];

  useEffect(() => {
    clients();
    users();
    if (loading == false) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [loading]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.linkedin.com/in.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = "lang: en_US";
    document.getElementsByTagName("head")[0].appendChild(script);

    script.onload = () => {
      if (window.IN && window.IN.FollowCompany) {
        window.IN.FollowCompany();
      }
    };

    return () => {
      // Cleanup when component unmounts
      document.getElementsByTagName("head")[0].removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages">
          <div className="page-cards">
            {pageCards.map((card) => (
              <div className="page-card mb-0">
                {/* <NavLink to={card.path} className="text-decoration-none" > */}
                <div className="card-details">
                  <div
                    className="card-detail-icon"
                    style={{ color: card.iconColor }}
                  >
                    {card.pageCardIcon}
                  </div>
                  <div className="card-detail">
                    <p>{card.pageCardtitle}</p>
                    <h4>{card.pageCardValue}</h4>
                  </div>
                </div>
                {/* </NavLink> */}
                <div className="card-footers ">
                  <p>
                    {card.pageCardFooterIcon} {card.pageCardFooterDes}
                  </p>
                </div>
              </div>
            ))}

            <div className="page-card">
              <a
                className="text-decoration-none"
                href="https://www.linkedin.com/company/gohoardings/"
              >
                <div className="card-details">
                  <div
                    className="card-detail-icon"
                    style={{ color: "#007bff" }}
                  >
                    <AiFillLinkedin />
                  </div>
                  <div className="card-detail">
                    {/* <p> Follower</p>
                    <h4> 3,150+</h4> */}
                    <div className="linkedin-follow-container">
                      {/* Replace '0000' with your actual LinkedIn Company ID */}
                      <script
                        type="IN/FollowCompany"
                        data-id="7961303"
                        data-counter="bottom"
                      ></script>
                    </div>
                  </div>
                </div>
              </a>
              <div className="card-footers ">
                <p>
                  <MdRefresh /> Just Updated
                </p>
              </div>
            </div>
          </div>
          <div className="page-cards dash-charts">
            <div className="dash-chart-left dash-chart">
              <div>
                <div className="page-cardm dash-chart-card">
                  <div className="chart-body">
                    <h4>Customer Feedback</h4>
                    <div className="chart-datas">
                      <div>
                        <div className="clearfix">
                          <p>Positive</p>
                          <p className="text-success">
                            <AiOutlineArrowUp />
                          </p>
                        </div>
                        <div className="progress">
                          <div
                            className="bg-success"
                            role="progressbar"
                            style={{ width: "70%" }}
                            aria-valuenow={70}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h4 className="text-success">8501</h4>
                      </div>
                      <div>
                        <div className="clearfix">
                          <p>Negative</p>
                          <p className="text-danger">
                            <AiOutlineArrowDown />
                          </p>
                        </div>
                        <div className="progress">
                          <div
                            className=" bg-danger"
                            role="progressbar"
                            style={{ width: "30%" }}
                            aria-valuenow={30}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h4 className="mt-10 text-danger">3251</h4>
                      </div>
                    </div>
                    <div className="chart-wrapper" style={{ height: 270 }}>
                      <Doughnut
                        data={data}
                        options={{
                          maintainAspectRatio: false,
                          legend: {
                            display: true,
                            labels: { fontFamily: "Poppins" },
                          },
                        }}
                        width={150}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dash-chart-right dash-chart">
              <div>
                <h5 className="card-title">Social Source</h5>
                <h4>50,500 </h4>
                <div style={{ marginTop: "1.429rem" }}>
                  <div className="clearfix">
                    <p>Facebook</p>
                    <p>801</p>
                  </div>
                  <div className="progress">
                    <div
                      className=" bg-info"
                      role="progressbar"
                      style={{ width: "80%" }}
                      aria-valuenow={80}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "1.429rem" }}>
                  <div className="clearfix">
                    <p>Twitter</p>
                    <p className="text-success">572</p>
                  </div>
                  <div className="progress">
                    <div
                      className=" bg-success"
                      role="progressbar"
                      style={{ width: "57%" }}
                      aria-valuenow={57}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div>
                <div
                  style={{ marginTop: "1.429rem", marginBottom: "1.429rem" }}
                >
                  <div className="clearfix">
                    <p>LinkedIn</p>
                    <p className="text-secondary ">766</p>
                  </div>
                  <div className="progress">
                    <div
                      className=" bg-secondary"
                      role="progressbar"
                      style={{ width: "76%" }}
                      aria-valuenow={76}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "1.429rem" }}>
                  <div className="clearfix">
                    <p>Google+</p>
                    <p className=" text-warning ">288</p>
                  </div>
                  <div className="progress">
                    <div
                      className=" bg-warning"
                      role="progressbar"
                      style={{ width: "28%" }}
                      aria-valuenow={28}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div>
                <div
                  style={{ marginTop: "1.429rem", marginBottom: "1.429rem" }}
                >
                  <div className="clearfix">
                    <p>Pinterest</p>
                    <p className=" text-danger ">710</p>
                  </div>
                  <div className="progress">
                    <div
                      className=" bg-danger"
                      role="progressbar"
                      style={{ width: "70%" }}
                      aria-valuenow={76}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoard;
